import { FoodGroupIdsAndAll } from '@/types/Food.types';

export const foodGroupI18n: { [key in FoodGroupIdsAndAll]: string } = {
  fruits: 'fruits',
  grains: 'grains',
  legumes: 'legumes',
  nuts: 'nuts',
  seeds: 'seeds',
  vegetables: 'vegetables',
  all: 'foods',
};

export const foodGroupEmoji: { [key in FoodGroupIdsAndAll]: string } = {
  fruits: '🍎',
  grains: '🌾',
  legumes: '🫘',
  nuts: '🥜',
  seeds: '🌱',
  vegetables: '🥦',
  all: '🥗',
};

export const foodGroupImage: { [key in FoodGroupIdsAndAll]: string } = {
  fruits:
    'https://images.unsplash.com/photo-1610832958506-aa56368176cf?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDA0NjI&ixlib=rb-4.0.3',
  grains:
    'https://images.unsplash.com/photo-1529511582893-2d7e684dd128?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDA3MTU&ixlib=rb-4.0.3',
  legumes:
    'https://images.unsplash.com/photo-1564894809611-1742fc40ed80?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDA3ODk&ixlib=rb-4.0.3',
  nuts: 'https://images.unsplash.com/photo-1543208541-0961a29a8c3d?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDA5MDI&ixlib=rb-4.0.3',
  seeds:
    'https://images.unsplash.com/photo-1598112155206-e9bec09497b3?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDEwMzI&ixlib=rb-4.0.3',
  vegetables:
    'https://images.unsplash.com/photo-1566385101042-1a0aa0c1268c?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDEyNjc&ixlib=rb-4.0.3',
  all: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?ixid=Mnw0MDMyMDF8MHwxfGFsbHx8fHx8fHx8fDE2Nzk1MDEyMTY&ixlib=rb-4.0.3',
};
